import { Modal, Space, Spin, Button, Typography, message } from "antd";
import { CrownOutlined } from "@ant-design/icons";
import { COLORS } from "../types/types";
import StripeWrapper from '../page/client/StripeWrapper';
import PaymentFormPremium from '../page/client/PaymentFormPremium';

const { Title, Text } = Typography;

interface PremiumModalProps {
  visible: boolean;
  profession: string | null;
  availability: any | null;
  checking: boolean;
  step: number;
  result: any | null;
  userId: number | null;
  onCancel: () => void;
  onPayment: () => void;
  onSuccess: (position: number) => void;
}

const PremiumModal: React.FC<PremiumModalProps> = ({
  visible,
  profession,
  availability,
  checking,
  step,
  result,
  userId,
  onCancel,
  onPayment,
  onSuccess,
}) => {
  return (
    <Modal
      title={<Space><CrownOutlined style={{ color: COLORS.secondary }} /> Devenir Premium - {profession}</Space>}
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={600}
      destroyOnClose
    >
      {checking ? (
        <div style={{ textAlign: "center", padding: 40 }}><Spin /></div>
      ) : availability ? (
        !availability.isAvailable ? (
          <div style={{ textAlign: "center", padding: 24 }}>Toutes les places sont prises.</div>
        ) : (
          step === 0 && (
            <>
              <div style={{ padding: 24, backgroundColor: COLORS.light, borderRadius: 8, marginBottom: 24 }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <div>
                    <Text type="secondary">Votre position</Text>
                    <div style={{ fontSize: 28, fontWeight: "bold", color: COLORS.secondary }}>
                      #{availability.nextPosition}
                    </div>
                  </div>
                  <div>
                    <Text type="secondary">Tarif</Text>
                    <div style={{ fontSize: 28, fontWeight: "bold" }}>{availability.price} €</div>
                  </div>
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 12 }}>
                <Button onClick={onCancel}>Annuler</Button>
                <Button
                  type="primary"
                  onClick={onPayment}
                  style={{ backgroundColor: COLORS.secondary, borderColor: COLORS.secondary }}
                >
                  Payer {availability.price} €
                </Button>
              </div>
            </>
          )
        )
      ) : null}

      {step === 1 && (
        <StripeWrapper>
          <PaymentFormPremium
            amount={availability?.price || 0}
            professionId={availability?.professionId || 0}
            userId={userId!}
            professionName={profession || ''}
            onSuccess={(position) => onSuccess(position)}
            onCancel={onCancel}
          />
        </StripeWrapper>
      )}

      {step === 2 && result && (
        <div style={{ textAlign: "center", padding: 32 }}>
          <div style={{ fontSize: 48, color: COLORS.primary }}>✓</div>
          <Title level={3}>Paiement réussi !</Title>
          <Text>Position #{result.data?.position}</Text>
        </div>
      )}
    </Modal>
  );
};

export default PremiumModal;